import type { SupabaseClient } from '@supabase/supabase-js';

export async function getBenefits(balancedSupabase: SupabaseClient) {
	const { data: benefits, error } = await balancedSupabase.from('benefits').select('*').order('id');

	if (error) {
		console.error(error);
		return [];
	}
	return benefits;
}
